export default "__VITE_ASSET__BqAH5MLn__"